// removed by extract-text-webpack-plugin
module.exports = {"title":"_1-UR7YRw1ev1heEavpzf6","filters":"_34p3_eXnLB2YdxLa-o1QyJ","filter":"_10bo-6iUHI6ys3eDa9OhPP","label":"_35s7dbWc6e-Eh7uzD2jSN6","item":"_2Mk3gcaHSUmwcuwhb7Apxx","buttonLoadMore":"_2zXX8wVQTi7To9XR8AkDmk","spinner":"_3pdNwBy_PefoE9TpUdkQK8","searchField":"O-7LXaNKgbqm3K0fjicxl","row":"BCGHZI1l-qjJJ04LXPYxY","info":"_3rI5LMnFRxKRMu9M3dIGNl","type":"_2a1Gu9VUxTcj4Jh1PS4yLt","date":"_3-DDOtqy3DrRqUM26C0fnP","tags":"_3GGkhz7SMcbCICutETCOsB","more":"UFj8vDl47rzogZ-blq9Ge","expanded":"_2SycVWLpikW15sys__dO7Z"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Transactions/style.scss
// module id = 1260
// module chunks = 0